import CloseIcon from 'assets/images/closeSquare.png';
import 'assets/styles/app.scss';
import { StatisticInterface } from 'features/customerPanel/cpPlayerProfile/interface/interface';
import { fetchRegistrationBanners, getStatScoreId } from 'features/Home';
import { vipUserDataLayer } from 'features/login/util/utility';
import WebView from 'features/webView/utils';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { vipLevelArray } from 'shared/constants/common';
import { BetslipEvents, DepositEvents, setDataLayer } from 'shared/constants/datalayer';
import { fetchLiveEvents } from 'shared/hoc/store/layout.action';
import { generateSessionId } from 'shared/hooks/useBetslipAnalytics';
import useResolvedColorScheme from 'shared/hooks/useResolvedColorScheme';
import { BalanceState, CouponState, State } from 'shared/interface';
import { getAnalyticalData } from 'shared/util/analytical';
import { fetchCategoriesFlag } from '../../features/sports/store/sport.action';
import { useEventStartFilters } from '../hooks/useEventStartFilters';
import { fetchLocalisation } from '../util/localization';

const makeId = (length: number) => {
	let result = '';
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
};

const StateWatcher: React.FC = () => {
	const location = useLocation();
	const { userDetails } = useSelector<State, any>((state) => state.login);
	const { resolvedColorScheme } = useResolvedColorScheme();
	const coupon = useSelector<State, CouponState>((state) => state.coupon);
	const balanceData = useSelector<State, BalanceState>((state) => state.cpPanel.balanceData);
	const [balance, setBalance] = useState(balanceData.mainBalance);
	const [balanceCount, setBalanceCount] = useState(balanceData.depositCounter);
	const statsData: StatisticInterface = useSelector((state: RootStateOrAny) => state.playerProfile.playerStats);
	const { refreshCategories } = useEventStartFilters();

	useEffect(() => {
		if (balance === null && balanceCount === null) {
			setBalance(balanceData.mainBalance);
			setBalanceCount(balanceData.depositCounter);
		}

		if (balanceData.mainBalance && balanceData.depositCounter) {
			if (balance !== null && balanceCount !== null && balanceData.mainBalance > balance && balanceData.depositCounter > balanceCount) {
				const deposited = balanceData.mainBalance - balance;

				if (balanceData.depositCounter <= 3) {
					if (balanceData.depositCounter === 1) {
						setDataLayer(DepositEvents.FIRST_TIME_DEPOSIT(deposited));
					} else if (balanceData.depositCounter === 2) {
						setDataLayer(DepositEvents.SECOND_TIME_DEPOSIT(deposited));
					} else if (balanceData.depositCounter === 3) {
						setDataLayer(DepositEvents.THIRD_TIME_DEPOSIT(deposited));
					}
				}

				setBalance(balanceData.mainBalance);
				setBalanceCount(balanceData.depositCounter);
			}
		}
	}, [balanceData]);

	useEffect(() => {
		const handleBeforeUnload = () => {
			if (coupon?.bets.outcomes.length > 0 && userDetails?.userId) {
				setDataLayer(BetslipEvents.BET_ABANDON(getAnalyticalData(coupon)));
			}
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [coupon?.bets.outcomes.length, userDetails?.userId]);

	useEffect(() => {
		if (!userDetails.login) {
			let generatedUserName = localStorage.getItem('user');
			if (!generatedUserName) {
				generatedUserName = makeId(8);
				localStorage.setItem('user', generatedUserName);
			}

			WebView.broadcast('USER_LOGGEDOUT');
		} else {
			WebView.broadcast('USER_UPDATED', { userId: userDetails.userId });
		}
	}, [userDetails]);

	useEffect(() => {
		document.body.setAttribute('data-theme', resolvedColorScheme);
	}, [resolvedColorScheme]);

	useEffect(() => {
		generateSessionId();
		const closeIcon = document.getElementById('optiRealclosePopupImage') as HTMLImageElement;
		if (closeIcon?.src) {
			closeIcon.src = CloseIcon;
		}
	}, []);

	const dispatch = useDispatch();

	useEffect(() => {
		let a: any = null;
		dispatch(fetchRegistrationBanners());
		dispatch(fetchLiveEvents());
		a = setInterval(async () => {
			dispatch(fetchLiveEvents());
		}, 60000);
		return () => clearInterval(a);
	}, [dispatch]);

	useEffect(() => {
		fetchLocalisation();

		void refreshCategories();

		dispatch(fetchCategoriesFlag());
		dispatch(getStatScoreId());
	}, [dispatch]);

	const userId = userDetails.userId;
	const userEmail = userDetails.email;
	const userMobileNumber = userDetails.mobileNumber;
	const userDepositCounter = userDetails.depositCounter;
	const vipLevel = userDetails.vipStatusData;

	useEffect(() => {
		if (userId) {
			setDataLayer({
				customerID: userId,
				customerEmail: userEmail,
				customerPhone: userMobileNumber,
				customerDepositCount: userDepositCounter,
				vip: vipUserDataLayer(vipLevelArray[vipLevel]) || userDetails.vip,
			});

			if (!isEmpty(statsData)) {
				setDataLayer({
					playerTotalCoupons: statsData.totalBets,
					playerHighestWin: statsData.biggestWin,
					playerHighestOdds: statsData.biggestOdd,
					playerFavDiscipline: statsData.favouriteCategory,
				});
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, userId, statsData]);

	return null;
};

export default StateWatcher;
